var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconNavigationMenuVertical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.362 20.628a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0Zm0-17.25a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0Zm0 8.625a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconNavigationMenuVertical);
export default __webpack_public_path__ + "static/media/streamline-icon-navigation-menu-vertical.4b39540c.svg";
export { ForwardRef as ReactComponent };